import * as React from "react";
import { SVGProps } from "react";

const PtokensBtc = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}>
    <path
      fill="#f66"
      d="M29.3 29.3c-39.1 39.1-39.1 102.4 0 141.4L170.7 29.3c-39-39.1-102.4-39.1-141.4 0z"
    />
    <path
      fill="#da5f5a"
      d="M170.7 170.7c-39-39.1-102.4-39.1-141.4 0L170.7 29.3c39.1 39 39.1 102.4 0 141.4z"
    />
    <ellipse
      cx={100}
      cy={100}
      fill="#fff4c7"
      fillRule="evenodd"
      clipRule="evenodd"
      rx={63.9}
      ry={64.1}
    />
    <path
      fill="#fff4c7"
      d="M170.7 170.7c-39 39.1-102.4 39.1-141.4 0 39-39 102.4-39 141.4 0z"
    />
    <circle cx={100} cy={100} r={54.6} fill="#f7931a" />
    <path
      fill="#fff"
      d="M114.2 93.1c-1.7 6.8-12.1 3.3-15.5 2.5l3-12c3.3.9 14.2 2.4 12.5 9.5zm-1.9 19.3c-1.9 7.4-14.4 3.4-18.5 2.4l3.3-13.2c4.1 1.1 17.2 3.1 15.2 10.8zM126 93.2c1.1-7.3-4.5-11.2-12-13.8l2.5-9.8-6-1.5-2.4 9.6c-1.6-.4-3.2-.8-4.8-1.1l2.4-9.7-6-1.5-2.5 9.8c-1.3-.3-2.6-.6-3.8-.9l-8.3-2.1-1.6 6.4s4.5 1 4.4 1.1c2.4.6 2.9 2.2 2.8 3.5l-2.8 11.2c.2 0 .4.1.6.2-.2 0-.4-.1-.6-.2L84 110.1c-.3.7-1.1 1.8-2.7 1.4.1.1-4.4-1.1-4.4-1.1l-3 6.9 7.8 1.9c1.5.4 2.9.7 4.3 1.1l-2.5 10 6 1.5 2.5-9.9c1.6.4 3.2.9 4.8 1.2l-2.5 9.8 6 1.5 2.5-9.9c10.2 1.9 17.9 1.2 21.2-8.1 2.6-7.4-.1-11.7-5.5-14.5 3.8-.8 6.7-3.4 7.5-8.7z"
    />
  </svg>
);

export default PtokensBtc;
